<template>
  <v-lazy min-height="24px" :options="{ threshold: 0.1 }" transition="fade-transition">
    <div class="d-inline-flex align-center" v-bind="$attrs">
      <div class="mr-2 rounded-sm" style="width: 14px; height: 14px" :class="`inline-block bg-${riskProfileColor(riskProfile)}`" />
      <span>{{ $t(`assets.riskProfile.${riskProfile}`) }}</span>
    </div>
  </v-lazy>
</template>

<script setup lang="ts">
const { riskProfile = RiskProfile.UNKNOWN } = defineProps<{ riskProfile?: RiskProfile }>()
</script>
